
<div class="mat-intro-panel-backdrop mat-intro-panel-backdrop-top"
    [ngStyle]="{'height.px': top}"></div>
<div class="mat-intro-panel-backdrop mat-intro-panel-backdrop-right" 
    [ngStyle]="{'top.px': top, 'left.px': left + width, 'width.px': windowWidth - width - left, 'height.px': height}"></div>
<div class="mat-intro-panel-backdrop mat-intro-panel-backdrop-bottom"
    [ngStyle]="{'height.px': windowHeight - height - top, 'top.px': height + top}"></div>
<div class="mat-intro-panel-backdrop mat-intro-panel-backdrop-left"
    [ngStyle]="{'top.px': top, 'width.px': left, 'height.px': height}"></div>

<mat-card class="mat-intro-panel mat-snack-bar-container app-acrylic mat-elevation-z8" #panelElement @panel [ngStyle]="{top: panelTop, left: panelLeft}" [ngClass]="{
    'mat-intro-panel-arrow': width > 0 && height > 0,
    'mat-intro-panel-arrow-end': panelLeft === '100%' && translateX === '-100%',
    'mat-intro-panel-arrow-above': panelTop === '-16px' && translateY === '-100%',
    'mat-intro-panel-arrow-before': panelLeft === 'calc(100% + 16px)' && translateX === '0%'
}">
    <mat-card-content fxLayout="row" style="gap: 16px">
        <mat-user-picture mat-card-avatar [src]="'assets/'+ this.face +'.png'"></mat-user-picture>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span>Portail Oxance</span>
            <small class="mat-grey">Aide à la navigation</small>
        </div>
        <button mat-icon-button (click)="intro.end()" style="margin-left: auto"><mat-icon>close</mat-icon></button>
    </mat-card-content>
    <mat-card-content>
        {{step.message}}
    </mat-card-content>
    <mat-card-content *ngIf="step.index === 0">
        <small class="mat-grey">Vous pouvez interrompre à tout moment en cliquant sur la croix en haut à droite.</small>
    </mat-card-content>
    <mat-card-actions fxLayout="row" fxLayoutAlign="space-between center">
        <small class="mat-grey" style="margin-left: 8px">{{step.index + 1}} / {{step.total}}</small>
        <small class="mat-grey" style="margin-right: 8px" *ngIf="step.next !== undefined">
            Completez l'action pour continuer...
        </small>
        <button mat-button *ngIf="step.next === undefined && step.index < step.total - 1" (click)="intro.next()"
            [disabled]="intro.elementWaitingSubscription && !intro.elementWaitingSubscription.closed">
            {{step.index === 0 ? 'C\'est parti' : 'Suivant'}} <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-button *ngIf="step.next === undefined && step.index === step.total - 1" (click)="intro.end()">
            <mat-icon>check</mat-icon> Terminer
        </button>
    </mat-card-actions>
</mat-card>
